import { namespacer } from 'helpers'

const namespace = namespacer('STRIPE')

export const REGISTER_ELEMENTS = namespace('REGISTER_ELEMENTS')
export const ELEMENTS_CHANGED = namespace('ELEMENTS_CHANGED')
export const UNREGISTER_ELEMENTS = namespace('UNREGISTER_ELEMENTS')
